import type { AxiosRequestConfig } from 'axios'


export enum HandleError {
  /**
   * Historically, this was the default option.
   * However, we prefer more explicit error handling.
   *
   * This option overrides the response, making it undefined,
   * which breaks the type safety of API methods
   * that are supposed to return `Promise<AxiosResponse>`.
   *
   * Therefore, we want to gradually remove this option
   * and replace it with `Rethrow` everywhere.
   *
   * @deprecated
   **/
  Ignore,
  Rethrow,
}

export const RETHROW_ERROR_AFTER_HANDLING: AxiosRequestConfig = {
  afterErrorHandling: HandleError.Rethrow,
}

declare module 'axios' {
  interface AxiosRequestConfig {
    afterErrorHandling?: HandleError
  }
}
